import { css } from "styled-components";
import { Toast } from "drywall";
import token from "styled-token";
import { spaceMixin } from "../spaceMixin";
import { statusDialogMixin } from "../statusDialogMixin";
/** @class AlertMixin */

/** @method */

export var AlertMixin = function AlertMixin(props) {
  return token({
    borderRadius: "radii.md",
    iconSize: "status.iconSize"
  }, function (_ref) {
    var iconSize = _ref.iconSize,
        borderRadius = _ref.borderRadius;
    return css(["", " border-radius:", "px;", "{flex:1 1 0;}flex-flow:row wrap;", "{margin-left:", "px;margin-top:", ";order:2;flex:1 1 100%;}"], statusDialogMixin(props), borderRadius, Toast.Body, Toast.Action, spaceMixin("sm", function (space) {
      return space.value + iconSize;
    })(props), spaceMixin("xs")(props));
  })(props);
};